(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ab-video-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('.ab-video-button');
    if (!button) return;
    const gallery = button.closest('media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
    const mediaId = button.dataset.abVideoId;
    const item = Array.from(gallery.querySelectorAll('[data-media-id]'))
      .find((element) => element.dataset.mediaId === mediaId);
    if (!item) return;
    gallery.setActiveMedia(mediaId, false);
    item.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      block: 'nearest',
      inline: 'nearest'
    });
    const video = item.querySelector('video');
    if (video) {
      video.controls = true;
      const playback = video.play();
      if (playback) playback.catch(() => {});
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cajita-aurora"] && !Shopify.designMode) return;
  try {
    (function(){
  if(window.__cajitaAuroraSelector) return;
  window.__cajitaAuroraSelector=true;
  var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  document.addEventListener('change',function(e){
    if(!e.target.matches('[data-ca-model]')) return;
    var box=e.target.closest('[data-cajita-aurora]'),opt=e.target.selectedOptions[0];
    var img=box.querySelector('[data-ca-image]');
    img.src=opt.dataset.image;img.alt=opt.dataset.title;
    box.querySelector('[data-ca-original]').textContent=opt.dataset.original;
    box.querySelector('[data-ca-price]').textContent=opt.dataset.price;
    box.querySelector('[data-ca-saving]').textContent=opt.dataset.saving;
    var price=box.querySelector('[data-ca-button-price]');if(price)price.textContent=opt.dataset.price;
  });
  document.addEventListener('click',async function(e){
    var btn=e.target.closest('[data-ca-choose]');if(!btn||btn.disabled)return;
    e.preventDefault();
    var box=btn.closest('[data-cajita-aurora]'),error=box.querySelector('[data-ca-error]');
    var model=box.querySelector('[data-ca-model]');
    var id=btn.dataset.caChoose==='light'?model.value:btn.dataset.caChoose;
    var controls=Array.from(box.querySelectorAll('button,select'));
    var states=controls.map(function(x){return x.disabled});
    controls.forEach(function(x){x.disabled=true});error.hidden=true;
    try{
      var keys=box.dataset.caKeys.split('|').map(function(k){return k.trim()}).filter(Boolean);
      var updates={},selectedKey=keys.find(function(k){return k.split(':')[0]===id});keys.forEach(function(k){updates[k]=k===selectedKey?1:0});if(!selectedKey)updates[id]=1;
      var body=keys.length?{updates:updates}:{items:[{id:Number(id),quantity:1}]};
      body.sections='cart-drawer,cart-icon-bubble';body.sections_url=window.location.pathname;
      var response=await fetch(root+(keys.length?'cart/update.js':'cart/add.js'),{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});
      var data=await response.json();if(!response.ok||data.status>=400)throw new Error(data.description||box.dataset.caErrorMessage);
      var drawer=document.querySelector('cart-drawer');
      if(box.closest('cart-drawer')&&drawer&&data.sections&&data.sections['cart-drawer'])drawer.renderContents(data);else window.location.reload();
    }catch(err){error.textContent=err.message||box.dataset.caErrorMessage;error.hidden=false;controls.forEach(function(x,i){x.disabled=states[i]});}
  });
})();
  } catch(e) { console.error(e); }
})();

})();
